import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

// ui-connect components
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from 'ui-connect';

// utils
import Translate from 'components/Translate';
import { groupRequestErrors } from 'utils/groups/GroupsUtil';

function GroupErrorDialog({ open, onClose, errorType }) {
    const { errorTitle, errorContent } = useMemo(() => {
        if (errorType === groupRequestErrors.groupDeleted) {
            return {
                errorTitle: 'group_unavailable_title',
                errorContent: 'group_unavailable_message'
            };
        } else if (errorType === groupRequestErrors.acceptRequestNoPermission) {
            return {
                errorTitle: 'group_request_not_accepted_modal_title',
                errorContent: 'group_request_not_accepted_modal_message'
            };
        } else if (errorType === groupRequestErrors.requestCancelled) {
            return {
                errorTitle: 'group_request_canceled_modal_title',
                errorContent: 'group_request_canceled_modal_message'
            };
        } else if (errorType === groupRequestErrors.invitationCancelled) {
            return {
                errorTitle: 'group_invitation_expired_modal_title',
                errorContent: 'group_invitation_expired_modal_message'
            };
        } else if (errorType === groupRequestErrors.announcementDeleted) {
            return {
                errorTitle: 'group_announcement_unavailable_modal_title',
                errorContent: 'group_announcement_unavailable_modal_message'
            };
        } else {
            return {
                errorTitle: null,
                errorContent: null
            };
        }
    }, [errorType]);

    return (
        errorTitle &&
        errorContent && (
            <Dialog open={open} onClose={onClose}>
                <DialogTitle>
                    <Translate ns="group" content={errorTitle} />
                </DialogTitle>
                <DialogContent>
                    <Translate ns="group" content={errorContent} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose}>
                        <Translate ns="common" content="button_ok" />
                    </Button>
                </DialogActions>
            </Dialog>
        )
    );
}

GroupErrorDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    errorType: PropTypes.oneOf([
        groupRequestErrors.groupDeleted,
        groupRequestErrors.acceptRequestNoPermission,
        groupRequestErrors.requestCancelled,
        groupRequestErrors.invitationCancelled,
        groupRequestErrors.announcementDeleted
    ])
};

export default GroupErrorDialog;
